import BatchImageUploader from "@/components/hashedBulkUpload";
import React, { useState} from 'react';

function UploadLensRemoved() {
  const [uploadConfig] = useState({
    imageKind: "lens-removed",
    directory: "lens-removed"
  });

  return (
    <BatchImageUploader 
      imageKind={uploadConfig.imageKind}
      directory={uploadConfig.directory}
    />
  );
}

export default UploadLensRemoved;